import script from "./Numeric.vue?vue&type=script&setup=true&lang=ts"
export * from "./Numeric.vue?vue&type=script&setup=true&lang=ts"

import "./Numeric.vue?vue&type=style&index=0&id=33483f00&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33483f00"]])

export default __exports__